import ExerciserCorrectionUserAnswer from "../../../others/courses/exercisers/ExerciserCorrectionUserAnswer";
import {isNullOrUndefined} from "../../../../services/Validator";
import SystemCorrectionDivider from "../../../dividers/SystemCorrectionDivider";
import ExerciserCorrectionText from "../../../texts/courses/exercisers/ExerciserCorrectionText";

export default function ExerciserCorrectionCard({   userSubmission,
                                                    isCorrect,
                                                    correction }) {
    // Used through the app to display single Question
    // Options list with corresponding explanations

    // BUILD
    if (isNullOrUndefined(userSubmission))
        return null
    return (
        <div className={"px-[16px] overflow-hidden sm:overflow-auto w-full bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px] flex flex-col mt-[24px] pb-[16px]"}>
            {/** CONTENT */}
            <ExerciserCorrectionUserAnswer userSubmission={userSubmission} />
            {/** ---- DIVIDER */}
            {isCorrect === false && (
                <SystemCorrectionDivider />
            )}
            {/** ---- BOTTOM PART */}
            <ExerciserCorrectionText isCorrect={isCorrect}
                                     correction={correction} />
        </div>
    );
}